module.exports = __webpack_public_path__ + "img/18.26fe3768.png";